import services from "../services";
import * as types from "./mutation-type";

export const ActionSetShippings = ({commit}, payload) => {
    commit(types.SET_SHIPPINGS, payload)
}

export const ActionSetShippingMethodState = ({commit}, payload) => {
    commit(types.SET_SHIPPING_METHOD, payload)
}

export const ActionSetLoadingCalculate = ({commit}, payload) => {
    commit(types.SET_LOADING_CALCULATE, payload)
}

export const ActionShippingCalculate = async ({dispatch}, payload) => {
    dispatch('ActionSetLoadingCalculate', true)
    await services.shippingCalculate(payload)
    .then(async(response) => {
        let {error=false, msg, data} = await response.data
        dispatch('ActionSetLoadingCalculate', false)
        if(error) {
            throw msg
        }
        dispatch('ActionSetShippings', data)
        // dispatch('ActionSetShippingMethodState', null)
    })
    .catch((error) => { 
        dispatch('ActionSetLoadingCalculate', false)
        throw error
    })
}

export const ActionShippingCalculateByProduct = async ({_}, {payload, id}) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.getShippingCalculateByProduct(payload, id)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionGetCepDestination = ({ commit }, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.getCepDestination()
        if(!data?.error) {
            commit(types.SET_CEP_DESTIONATION, data.data);
            resolve(data)
        }
        reject(data)
    })
}

export const ActionGetCities = async ({_}, {payload, page}) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.getCities(payload, page)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionGetShippingMethod = ({ dispatch, commit }, payload) => {
    return new Promise(async(resolve, reject) => {
        commit(types.START_REQUEST)
        try {
            const { data } = await services.getShippingMethod(payload)
            if(!data?.error) {
                dispatch('ActionSetShippingMethodState', data.data)
                resolve(data)
            }
            reject(data)
        } catch (error) {
            reject(error)
        } finally {
            commit(types.FINISH_REQUEST)
        }
    })
}

export const ActionDestroySessionShippingMethod = ({ _ }, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.destroySessionShippingMethod()
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionSetShippingMethod = async ({dispatch, commit}, payload) => {
    if (!payload?.shippingMethod) {
        dispatch('ActionSetShippingMethodState', null)
        await dispatch('ActionDestroySessionShippingMethod')
        return;
    }
    commit(types.START_REQUEST)
    await services.setShippingMethod(payload)
    .then(async (response) => {
        let {error=false, msg, data, quote_expired=false} = await response.data
        if(error) {
            // frete fora da cotacao atual: quem chamou recarrega as opcoes
            throw quote_expired ? {msg, quoteExpired: true} : msg
        }
        dispatch('ActionSetShippingMethodState', payload.shippingMethod)
        dispatch('cart/ActionSetItemsCart', data, {root:true})
    })
    .catch((error) => {throw error})
    .finally(() => commit(types.FINISH_REQUEST))
}

export const ActionGetAllShippingCalculation = async ({dispatch, commit}) => {
    dispatch('ActionSetLoadingCalculate', true)
    commit(types.START_REQUEST)
    await services.getAllShippingCalculation()
    .then(async (response) => {
        dispatch('ActionSetLoadingCalculate', false)
        let {error=false, msg, data} = await response.data
        if(error) {
            alert(msg)
            return
        }
        dispatch('ActionSetShippings', data)
        dispatch('ActionSetShippingMethodState', null)
    })
    .catch((error) => {
        dispatch('ActionSetLoadingCalculate', false)
        throw error
    })
    .finally(() => commit(types.FINISH_REQUEST))
}